import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../toast-custom.css";
// https://kifpolc.liara.run
export const api = axios.create({
  baseURL: "https://kifpolc.liara.run/api/v1/",
});
export const api2 = axios.create({
  baseURL: "https://cardinfo.ir/inquiry/apiv1",
});

export const handleToast = (type, txt) => {
  toast[type](txt, {
    position: "top-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    className: "my-toast",
  });
};

export const reLoadPage = () => {
  localStorage.removeItem("login");
  window.location.href = "/login";
};
